import React from 'react';
import styled from 'styled-components/macro';
import VideoPlaceholder from 'assets/avatars/video-placeholder.png';
import { ChannelMessageAttachmentUploadStatus } from 'shared/types/graphql';

interface IVideoAttachmentProps {
  url?: string;
  uploadStatus?: ChannelMessageAttachmentUploadStatus;
}

const getUploadStatusMessage = (uploadStatus = ChannelMessageAttachmentUploadStatus.InProgress): string | null => {
  switch (uploadStatus) {
    case ChannelMessageAttachmentUploadStatus.InProgress:
      return 'Your video is being processed';
    case ChannelMessageAttachmentUploadStatus.Error:
      return 'Oops, there was an issue processing your video';
    default:
      return null;
  }
};

const VideoAttachment = ({ url, uploadStatus }: IVideoAttachmentProps): JSX.Element => {
  return (
    <VideoContainer>
      <UserMessage>{getUploadStatusMessage(uploadStatus)}</UserMessage>
      <video src={uploadStatus === ChannelMessageAttachmentUploadStatus.Success ? url : VideoPlaceholder} controls />
    </VideoContainer>
  );
};

export default VideoAttachment;

const VideoContainer = styled.div`
  max-width: 638px;
  position: relative;
`;

const UserMessage = styled.h2`
  color: #fff;
  left: 50%;
  opacity: 0.6;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
`;
